import INVOICE_WIDGETS from "@/configuration/widgets/INVOICE_WIDGETS";
import i18n from "@/language/i18n";

const INVOICE_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    TIMESHEET_BILLING_MODULE_WINDOW_ID: 'timesheetBilling'
});

export { INVOICE_MODULE_WINDOW_IDENTIFIER };

export default {
    INVOICE_GROUP_WRAPPER: {
        type: 'group',
        id: 'invoices',
        label: i18n.t('ModuleRegistry.groups.invoices.name'),
        children: [],
        icon: '$wCall',
        sidebarIcon: '$wNavInvoice'
    },
    CHILDREN: {
        TIMESHEET_BILLING_MODULE: {
            type: 'module',
            id: 'timesheetBilling',
            windowIdentifierType: INVOICE_MODULE_WINDOW_IDENTIFIER.TIMESHEET_BILLING_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.invoices.timesheetBilling.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/timesheetBilling',
            widgets: INVOICE_WIDGETS.INVOICE_WIDGETS
        },
    }
}
